import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Debug } from "../../../../Molecules/Forms/Debug";
import { Button, Grid, Dialog, SubmitButton, makeStyles, AddTaskForm, EditTaskForm } from "../../../../";
var taskSchema = Yup.object().shape({
  name: Yup.string().min(2, "Too Short!").required("Campo obligatorio") // deadline: Yup.date().default(() => new Date()),
  // details: Yup.string().min(2, 'Too Short!').required('Campo obligatorio')

});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    form: {
      display: "flex"
    },
    repeat: {
      margin: 0
    },
    mr30: {
      "margin-right": "30px"
    },
    actions: {
      display: "flex",
      padding: "30px",
      "justify-content": "flex-end"
    },
    repeatField: {
      width: "50%",
      "margin-right": "20px"
    },
    flex: {
      display: "flex"
    }
  };
});

var DialogFranchiseAddTask = function DialogFranchiseAddTask(_ref) {
  var translation = _ref.translation,
      variant = _ref.variant,
      createTask = _ref.createTask,
      editTask = _ref.editTask,
      onClose = _ref.onClose,
      heading = _ref.heading,
      props = _objectWithoutProperties(_ref, ["translation", "variant", "createTask", "editTask", "onClose", "heading"]);

  var initialValues = {
    name: "",
    date: null,
    start: null,
    end: null,
    repeat: false,
    type: "",
    frequency: "",
    weekdays: [],
    extraFields: [{
      "options": [{
        "name": ""
      }],
      "name": "t",
      "type": "textarea",
      "isMandatory": false
    }],
    // extraFields: [{
    //   name: "",
    //   type: "textarea",
    //   isMandatory: false,
    //   options: []
    // }],
    status: "pending"
  };
  var classes = useStyles();
  return [/*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "lg",
    title: translation ? variant === "add" ? translation.titles.add_task : translation.titles.edit_task : "Añadir tarea",
    open: props.open,
    onClose: props.onClose,
    mode: variant,
    key: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: props.task || initialValues,
    validationSchema: taskSchema,
    onSubmit: function onSubmit(values) {
      // console.log("values en Franchise AddTask", values);
      // setTimeout(() => {
      // 	alert(JSON.stringify(values, null, 2));
      // }, 500);
      // console.log(JSON.stringify(values));
      variant === "add" ? createTask(_objectSpread(_objectSpread({}, values), {}, {
        repeat: values.type === "recurring"
      })) : editTask(values);
      onClose();
    },
    render: function render(_ref2) {
      var values = _ref2.values,
          setFieldValue = _ref2.setFieldValue,
          handleBlur = _ref2.handleBlur,
          isValid = _ref2.isValid,
          isSubmitting = _ref2.isSubmitting;
      return /*#__PURE__*/React.createElement(Form, {
        "data-cy": "dialog-checklist",
        className: classes.form
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.root
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: classes.editor
      }, variant === "add" ? /*#__PURE__*/React.createElement(AddTaskForm, {
        values: values,
        mode: variant,
        franchise: true,
        translation: translation ? translation : null
      }) : /*#__PURE__*/React.createElement(EditTaskForm, {
        values: values,
        mode: variant,
        heading: heading,
        franchise: true,
        translation: translation ? translation : null
      })), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: onClose
      }, translation ? translation.buttons.cancel : "Cancelar"), /*#__PURE__*/React.createElement(Button, {
        size: "medium",
        className: classes.mr30,
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, translation ? translation.buttons.save : "Guardar"))));
    }
  })))];
};

export { DialogFranchiseAddTask };